import { Component, OnInit, Input, ElementRef, ViewChild, AfterViewInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { QdeService } from "src/app/services/qde.service";
import { SharedServiceService } from "src/app/services/shared-service.service"
import { WSCallDetailsData, CreatUpdateLead } from "src/app/model/creat-update-lead";
import { IwService } from "src/app/services/iw.service";
import { Qde } from "src/app/model/qde";
import { Router } from "@angular/router";
import { GENERIC_ERROR, GENERIC_ERRORS, ISTATACARD, VALIDATION_MSG, TOOLTIPS, BRAND_APPROVED_ERRORS, IS_CAMPAIGN } from 'src/app/config/app-settings.config';
import { LoaderService } from 'src/app/services/loader.service';
import { ThemeService } from 'src/app/services/theme.service';
declare var _satellite: any;
declare var $: any;
declare var jQuery: any;
declare var AmoScript: Function;
declare var formEliteAdvSubmit: Function;
declare var analytics: any;

export interface Nations {
  value: string;
  viewValue: string;
}

@Component({
  selector: "app-personal",
  templateUrl: "./personal.component.html",
  styleUrls: ["./personal.component.scss"]
})
export class PersonalComponent implements OnInit{
  personalForm: FormGroup;
  wsDetails = new WSCallDetailsData();
  resiDetails = new CreatUpdateLead();
  nationality: any;
  eapplyFormLabel: any;
  executionId: any;
  @Input() masterData: any;
  @Input() banca1Form: FormGroup;
  cityList: any;
  city: any;
  state: any;
  resiStdCode: any;
  _channelCode: any;
  _promoGroup: any;
  _promoCode: any;
  _sourceCode: string;
  pinNotFound = false;
  providedPin: any;
  filterPin: any;
  pinList = [];
  dcrData: any;
  errorMessage: any;
  @ViewChild("matPersonalBlock") personalBlock: ElementRef;
  requestObj: Qde;
  TATACARD = ISTATACARD;
  actualPromoCode: any;
  genricError: any;
  isBanca: boolean;
  validationMsgs: any;
  tooltips: any;
  errorMessage1: any;
  partnerCode: any = sessionStorage.getItem('partner-code');
  containerType: any = sessionStorage.getItem('container-type');
  
  declarationText: any;
  disableQdeSubmit=0;
  constructor(
    private fb: FormBuilder,
    private qdeService: QdeService,
    private sharedData: SharedServiceService,
    private iw: IwService,
    private router: Router,
    private loaderService: LoaderService,
    private themeService: ThemeService
  ){
    console.log('pesonal-qde');
    this.partnerCode = this.themeService.partnerCode;
   }

  ngOnInit() {
    this.genricError = GENERIC_ERRORS;
    this.validationMsgs = VALIDATION_MSG;
    this.tooltips = TOOLTIPS;
    this.createForm();
    this.nationality = this.iw.getnationalityDropdown().dcrContent.root.name_value_pair;
    this.eapplyFormLabel = this.iw.geteapplyFormLabelDcr().dcrContent.root;
    this.f.fcnPincode.valueChanges.subscribe(value => {
      if (value && value.length >= 2 && this.pinList) {
        this.filterPin = this.pinList.filter(pin => ('' + pin).startsWith(value));
      } else {
        this.filterPin = null;
      }
      this.fetchCityFromPin();
    });
    this.isBanca = this.sharedData.paramschannel && this.sharedData.paramschannel == '901' ? true : false;
    if(this.eapplyFormLabel && this.eapplyFormLabel.submit_declaration_text){
      this.declarationText = this.eapplyFormLabel.submit_declaration_text;
    }
    
    this.sharedData.dcrObservable.subscribe((data:any)=>{
      if(data){
          let joiningFee:any;
          let annualFee:any;
          if(data && data.root && data.root.card_information && data.root.card_information.card_fee_container){
            joiningFee = data.root.card_information.card_fee_container.joining_fees;
            annualFee = data.root.card_information.card_fee_container.annual_fee_amount;
            if (this.declarationText.includes("{joining_fee}")) {
              this.declarationText = this.declarationText.replace(/{joining_fee}/g, joiningFee);
            }
            if (this.declarationText.includes("{annual_fee}")) {
              this.declarationText = this.declarationText.replace(/{annual_fee}/g, annualFee);
            }
          }
        }
      
    })
    // (document.documentElement || document.body).scrollTop = 0;
  }
  // ngAfterViewInit() {
  //   this.f.fcnConsent.setValue(true);
  // }

  get bf() {
    return this.banca1Form.controls;
  }
  ngOnChanges() {

    if (this.masterData) {
      if (this.sharedData.paramschannel && this.sharedData.paramschannel == '901') {
        this.cityList = this.masterData.bancaCityList;
      } else {
        this.cityList = this.masterData.cityList;
      }
      this.cityList?this.cityList.forEach(pinObj => { this.pinList.push(...pinObj.pin) }):true;
      if (this.pinList) {
        this.pinList = this.pinList.filter((v, i, a) => a.indexOf(v) === i);
      }
    }
  }

  readCardData(xml, keyName) {
    let xmlDoc = $.parseXML(xml),
      $xml = $(xmlDoc);
    return $xml.find(keyName)[0].innerHTML;
  }

  createForm() {
    this.personalForm = this.fb.group({
      fcnHouseNo: ["", [Validators.required, Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")]],
      fcnLocality: ["", [Validators.required, Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")]],
      fcnAddLine1: ["", Validators.pattern("[A-Za-z0-9\\s'()#,-./]*")],
      fcnPincode: ["", Validators.required,],
      fcnNationality: ["", Validators.required],
      fcnConsent: ["", Validators.required],
    });
  }
  public hasError = (controlName: string, errorName: string) => {
    return this.personalForm.controls[controlName].hasError(errorName);
  };

  get f() {
    return this.personalForm.controls;
  }

  trimObject(object) {
    object = Object.assign({}, object);
    let keys = Object.keys(object);
    keys.forEach(element => {
      if (typeof object[element] == "string" && object[element]) {
        object[element] = object[element].trim();
      } else if (typeof object[element] == "object" && object[element] && element != 'WSCallUserDOB' && element != 'dateOfBirth') {
        object[element] = this.trimObject(object[element]);
      }
    });
    return object;
  }

  onSubmit() {
    if(this.disableQdeSubmit){
      return;
    }

    if (this.pinNotFound) {
      return;
    } else if (this.personalForm.invalid) {
      Object.keys(this.f).forEach(key => {
        this.personalForm.get(key).markAsTouched();
      });
      return;
    } else {
      if (IS_CAMPAIGN) {
        window["page"] = 'ev_application_complete';
        window["transactionId"] = this.sharedData.amoSequeceNumber ? this.sharedData.amoSequeceNumber : '';
        AmoScript();
      }
      let initialFormData = Object.assign(
        {},
        this.qdeService.aboutData,
        this.qdeService.professionalData
      );
      let dob: any = new Date(initialFormData.WSCallUserDOB);
      console.log('dob',dob);
      
      const d = dob.getDate();
      const m = dob.getMonth() + 1;
      const y = dob.getFullYear();
      dob = `${(d + "").length === 1 ? "0" + d : d}-${
        (m + "").length === 1 ? "0" + m : m
        }-${y}`;

      this.requestObj = new Qde();
      this.requestObj.salutation = initialFormData.WSCallUserSalutation;
      this.requestObj.firstName = initialFormData.WSCallUserFirstName;
      this.requestObj.middleName = initialFormData.WSCallUserMiddleName;
      this.requestObj.lastName = initialFormData.WSCallUserLastName;
      this.requestObj.gender = initialFormData.WSCallUserGender;
      this.requestObj.dateOfBirth = dob;
      this.requestObj.pan = initialFormData.WSCallUserPanNumber;
      this.requestObj.nationality = this.f.fcnNationality.value || null;
      this.requestObj.resiAddressLine1 = this.f.fcnHouseNo.value || null;
      this.requestObj.resiAddressLine2 = this.f.fcnAddLine1.value || null;
      this.requestObj.resiAddressLine3 = this.f.fcnLocality.value || null;
      this.requestObj.resiPinCode = this.f.fcnPincode.value || null;
      this.requestObj.resiCity = initialFormData.WSCallUserCity;
      this.requestObj.mobileNumber = initialFormData.WSCallUserMobileNumber;
      this.requestObj.personalEmailId = initialFormData.WSCallUserEmailId;
      this.requestObj.occupationType = initialFormData.WSCallUserOccupationCode;
      this.requestObj.companyName = initialFormData.WSCallUserCompany;
      this.requestObj.designation = initialFormData.WSCallUserDesignation;
      this.requestObj.netIncome = initialFormData.WSCallUserAnnualIncomeValue;
      this.requestObj.offPinCode = initialFormData.WSCallUserOfficePincode;
      this.requestObj.eStatement = "E";
      this.requestObj.resiStdCode = this.resiStdCode;
      this.requestObj.sbiCardRelNumber = this.bf.fncSBIRelationship ? this.bf.fncSBIRelationship.value : null;
      this.requestObj.housingLoan = this.bf.fcnHouseLoan ? this.bf.fcnHouseLoan.value : null;
      this.requestObj.carLoan = this.bf.fcnCarLoan ? this.bf.fcnCarLoan.value : null;
      this.requestObj.savingsAccount = this.bf.fcnAccountNo ? this.bf.fcnAccountNo.value : null;
      this.requestObj.userId = "Y";
      this.requestObj.channelCode = this.isBanca ? 'EALB' : ((this.sharedData.paramschannel && this.sharedData.paramschannel == '701') ? "EABP" : this.sharedData.fromSwiftJourney ? "SAPL" : "EAPL");
      this.requestObj.cardType = initialFormData.WSCallCardType;
      this.requestObj.promoCode = this.sharedData.promoCode;
      this.requestObj.cardCategory = initialFormData.WSCallCardCategory;
      this.requestObj.geMid1 = initialFormData.WSCallGemId1;
      console.log("Value GEM1: ",this.requestObj.geMid1);
      this.sharedData.gemid1Val = this.requestObj.geMid1;
      this.requestObj.geMid2 = initialFormData.WSCallGemId2;
      this.sharedData.gemid2Val = this.requestObj.geMid2;
      console.log("Value GEM2: ",this.requestObj.geMid2);
      this.requestObj.executionId = this.qdeService.executionId || "";
      //this.requestObj.natureOfCompany = this.qdeService.natureOfCompany;
      this.requestObj.natureOfCompany = "";
      this.requestObj.desigNotInList = this.qdeService.designationFlag;
      this.requestObj.officeState = this.sharedData.officeState;
      this.requestObj.offStdCode = this.sharedData.offStdCode;
      this.requestObj.offCity = this.sharedData.officeCity;
      this.requestObj.leadorig = initialFormData.WSCallLeadOrigination;

      this.sharedData.occuVal = this.requestObj.occupationType;
      this.sharedData.channelVal = this.requestObj.channelCode;
      // =====================
      const resiFormData = {
        WSCallUserHouseNo: this.f.fcnHouseNo.value || "",
        WSCallUserLocality: this.f.fcnLocality.value || "",
        WSCallUserAddressLine: this.f.fcnAddLine1.value || "",
        WSCallUserResiPincode: this.f.fcnPincode.value || "",
        WSCallUserNationality: this.f.fcnNationality.value || "",
        WSCallUserCibelOtherConsent: (this.f.fcnConsent && this.f.fcnConsent.value == true) ? 'Y' : ((this.f.fcnConsent && this.f.fcnConsent.value == false) ? 'N' : ''),
        WSCallPromoCode: this.sharedData.promoCode
      };
      const allFormData = Object.assign(
        {},
        resiFormData,
        this.qdeService.secondSectionData
      );
      this.requestObj.cardReferralCode = initialFormData.WSCallCardReferralCode;
      this.requestObj.sourceCode = this.sharedData.sourceCode;
      this.requestObj.promoGroup = this.sharedData.promoGroup;
      this.requestObj.promoCode = this.sharedData.promoCode;
      this.resiDetails.wsCallDetailsData = allFormData;
      this.resiDetails = this.trimObject(this.resiDetails);
      this.callCreateUpdateLead(this.resiDetails);
    }
  
  /* Analytics added */
  if(window['analytics']){
    analytics.track('eapply__click__submit__residential_address_screen', {
      'MODE_OF_CONVERSION': '',
      'IS_ORGANIC': 'N',
      'SOURCE_GEM_ID1':  this.sharedData.paramsgemid1,
      'SOURCE_GEM_ID2':  this.sharedData.paramsgemid2,
      'SOURCE_PAGE_URL': window["digitalData"].page.SOURCE_PAGE_URL,
      'CHANNEL_NAME': this.sharedData.paramschannel,
      'JOURNEY_NAME': 'EAPPLY',
      'FIRST_NAME': this.qdeService.aboutData.WSCallUserFirstName,
      'LAST_NAME': this.qdeService.aboutData.WSCallUserLastName,
      'MIDDLE_NAME': this.qdeService.aboutData.WSCallUserMiddleName,
      'EMAIL': this.qdeService.aboutData.WSCallUserEmailId,
      'Mobile_no': this.qdeService.aboutData.WSCallUserMobileNumber,
      'CITY': this.qdeService.professionalData.WSCallUserCity,
      'COMPANY_NAME': this.qdeService.professionalData.WSCallUserCompany,
      'DOB': this.qdeService.professionalData.WSCallUserDOB,
      'DESIGNATION': this.qdeService.professionalData.WSCallUserDesignation,
      'ANNUAL_SALARY': this.qdeService.professionalData.WSCallUserAnnualIncomeValue,
      'OFFICE_PINCODE': this.qdeService.professionalData.WSCallUserOfficePincode,
      'pan': this.qdeService.professionalData.WSCallUserPanNumber,
      'RESI_ADDRESS': this.f.fcnAddLine1.value,
      'RESI_PINCODE': this.f.fcnPincode.value,
      'OCCUPATION_TYPE': this.qdeService.professionalData.WSCallUserOccupationCode,
      'CARD_TYPE': this.sharedData.sbic_card_Type,
      'current_ra_house_no': this.f.fcnHouseNo.value,
      'current_ra_locality': this.f.fcnLocality.value,
      'current_ra_addr_continue':this.f.fcnAddLine1.value,
      'current_ra_pincode':this.f.fcnPincode.value,
      'current_ra_nationality':this.f.fcnNationality.value
      });
    }
  }

  callQdeSubmit(obj) {
    if(this.disableQdeSubmit){
      return;
    }
    this.qdeService.qdeSubmit(obj).subscribe(
      (response: any) => {
        const qdeResponse = { ...response.body };
        if (qdeResponse && qdeResponse.qdeResponse && qdeResponse.qdeResponse.status && qdeResponse.qdeResponse.status.toLowerCase() === 'failure') {
          this.disableQdeSubmit = 0;
          window["digitalData"].error = { message: GENERIC_ERROR };
          if(window['_satellite']){
            _satellite.track('form_error');
          }
          if (qdeResponse.qdeResponse.errorCode && qdeResponse.qdeResponse.errorCode == "301") {
            this.errorMessage = BRAND_APPROVED_ERRORS.panStatus300;
          } else if (qdeResponse.qdeResponse.errorCode && qdeResponse.qdeResponse.errorCode == "103") {
            this.sharedData.abortMessage = BRAND_APPROVED_ERRORS.cardDeviationTrue;
            this.router.navigate(['', 'error']);
          } else if (qdeResponse.qdeResponse.errorCode && qdeResponse.qdeResponse.errorCode == "102") {
            this.errorMessage = BRAND_APPROVED_ERRORS.panDedupeAllowed;
          } else if (qdeResponse.qdeResponse.errorCode && qdeResponse.qdeResponse.errorCode == "100") {
            this.errorMessage = qdeResponse.qdeResponse.errorMessage;
            console.log("Error Msg against 100 error code is ", this.errorMessage);
          } else {
            this.errorMessage = GENERIC_ERROR;
          }
        } else if (qdeResponse.qdeResponse) {
          this.disableQdeSubmit = 1;
          window["digitalData"].decisionType = qdeResponse.qdeResponse.statusCode;
          // window["digitalData"].instantDecision = qdeResponse.qdeResponse.statusDesc;
          // window["digitalData"].eapply = { number: qdeResponse.qdeResponse.applicationNumber };
          // window["digitalData"].application = { status: "Complete" };
          window["digitalData"].eapply={instantDecision:qdeResponse.qdeResponse.statusDesc};
          window["digitalData"].application = { status: "Complete", number: qdeResponse.qdeResponse.applicationNumber };

          //window["digitalData"].card = { cardName: qdeResponse.qdeResponse.cardName };
          window["digitalData"].gemId1 = { GEMID1: this.requestObj.geMid1 };
          window["digitalData"].gemId2 = {GEMID2: this.requestObj.geMid2 };
       
          if(window['_satellite']){
            _satellite.track("eapply_instant_decision ");
          }

          let labelsDisplay: any
          if (this.eapplyFormLabel) {
            if (this.eapplyFormLabel.houseNumber_container && this.eapplyFormLabel.houseNumber_container.houseNumber_label) {
              labelsDisplay = this.eapplyFormLabel.houseNumber_container.houseNumber_label
            } if (this.eapplyFormLabel.locality_container && this.eapplyFormLabel.locality_container.locality_label) {
              labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.locality_container.locality_label
            } if (this.eapplyFormLabel.addressContinued_container && this.eapplyFormLabel.addressContinued_container.addressContinued_label) {
              labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.addressContinued_container.addressContinued_label
            } if (this.eapplyFormLabel.pinCode_container && this.eapplyFormLabel.pinCode_container.pinCode_label) {
              labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.pinCode_container.pinCode_label
            } if (this.eapplyFormLabel.nationality_container && this.eapplyFormLabel.nationality_container.nationality_label) {
              labelsDisplay = labelsDisplay + "|" + this.eapplyFormLabel.nationality_container.nationality_label
            }
          }

          // formEliteAdvSubmit(this.sharedData.cardName, 'Personal Details', labelsDisplay)
          let pageLableFroDecsionCode: any
          if (qdeResponse.qdeResponse.statusCode) {
            if (qdeResponse.qdeResponse.statusCode == 'FFMP'|| qdeResponse.qdeResponse.statusCode == '170') {
              pageLableFroDecsionCode = 'ev_Approved'
            } else if (qdeResponse.qdeResponse.statusCode == '120') {
              pageLableFroDecsionCode = 'ev_Referred'
            } else if (qdeResponse.qdeResponse.statusCode == 'FD') {
              pageLableFroDecsionCode = 'ev_Decline'
            } else if (qdeResponse.qdeResponse.statusCode == '148' || qdeResponse.qdeResponse.statusCode == '147' || qdeResponse.qdeResponse.statusCode == '142') {
              pageLableFroDecsionCode = 'ev_Null'
            } else{
              pageLableFroDecsionCode = 'ev_Null'
            }
          }
          if (IS_CAMPAIGN) {
            window["page"] = pageLableFroDecsionCode;
            window["transactionId"] = this.sharedData.amoSequeceNumber ? this.sharedData.amoSequeceNumber : '';
            AmoScript();
          }
          this.qdeService.qdeSubmitData = qdeResponse.qdeResponse;
          this.sharedData.qdeSuccessResponse = qdeResponse.qdeResponse;
          this.sharedData.flagsFromQdeResponse = qdeResponse;
          this.sharedData.applicantApplicationNumber = qdeResponse.qdeResponse.applicationNumber;
          let accessToken: any;
          let expiryTime: any;
          this.errorMessage = '';
          if (response.headers && response.headers.get("access_token")) {
            accessToken = response.headers.get("access_token");
          }
          if (response.headers && response.headers.get("expiry_time")) {
            expiryTime = response.headers.get("expiry_time");
          }

          if (accessToken) {
            sessionStorage.setItem("s24_access_token", accessToken);
          }
          if (expiryTime) {
            sessionStorage.setItem("s24_expiry_time", expiryTime);
          }
          this.sharedData.qdeSubmitData = this.resiDetails.wsCallDetailsData;
          this.sharedData.navigateToCompleteApp = qdeResponse.enableDataCaptureFlag;
          this.sharedData.navigateToDocUpload = qdeResponse.enableDocumentListFlag;
          this.sharedData.navigateToScheduleAppointment = qdeResponse.enableAppointmentFlag;
          this.sharedData.navigateToAddon = qdeResponse.enableAddOnListFlag;
          this.sharedData.navigateToCrossSell = qdeResponse.enableCrossSellFlag;
          this.sharedData.navigateToResheduleAppointment = qdeResponse.enableReSchdAppointmentFlag ? qdeResponse.enableReSchdAppointmentFlag : false;
          this.sharedData.isSubmit = true;
          this.router.navigate(['', 'apply', 'decisioning']);
        } else {
          this.errorMessage = GENERIC_ERROR;
          this.disableQdeSubmit =0;
        }
      }, err => {
        this.disableQdeSubmit = 0;
        this.errorMessage = GENERIC_ERROR;
        window["digitalData"].error = { message: GENERIC_ERROR };
        if(window['_satellite']){
          _satellite.track('form_error');
        }
      }
    );
  }

  callCreateUpdateLead(reqBody) {
    this.qdeService.createUpdateLead(reqBody).subscribe(
      (res: any) => {
        if (res.LeadGenerationRes.WSCallStatusCode === "000") {
          let sequenceId = res.LeadGenerationRes.WSCallSequenceId ? res.LeadGenerationRes.WSCallSequenceId : '';
          this.sharedData.amoSequeceNumber = sequenceId;
          this.errorMessage = '';
          this.errorMessage1 = '';
          this.requestObj.leadSeqId = res.LeadGenerationRes.WSCallSequenceId;
          this.callQdeSubmit(this.requestObj);
          this.errorMessage = '';
        } else if (res.LeadGenerationRes && res.LeadGenerationRes.WSCallStatusCode == "108" && res.LeadGenerationRes.WSCallStatusDescription) {
          this.errorMessage1 = BRAND_APPROVED_ERRORS.duplicateRecord;
          this.errorMessage = '';
          window["digitalData"].error = { message: GENERIC_ERROR };
          if(window['_satellite']){
            _satellite.track('form_error');
          }
        } else if (res.LeadGenerationRes && res.LeadGenerationRes.WSCallStatusCode !== "000" && res.LeadGenerationRes.WSCallStatusDescription) {
          this.errorMessage = res.LeadGenerationRes.WSCallStatusDescription;
          this.qdeService.professionalData = "";
          window["digitalData"].error = { message: GENERIC_ERROR };
          if(window['_satellite']){
            _satellite.track('form_error');
          }
        }
      }, err => {
        window["digitalData"].error = { message: GENERIC_ERROR };
        if(window['_satellite']){
          _satellite.track('form_error');
        }
        this.errorMessage = GENERIC_ERROR;
        this.qdeService.professionalData = "";
        this.errorMessage1 = '';
      }
    );
  }

  fetchCityFromPin() {
    if (this.f.fcnPincode.value.length == 6 && this.masterData) {
      let cityList: any;
      if (this.sharedData.paramschannel && this.sharedData.paramschannel == '901') {
        cityList = this.masterData.bancaCityList;
      } else {
        cityList = this.masterData.cityList;
      }
      this.providedPin = cityList.find(
        city => city.pin.includes(this.f.fcnPincode.value) >= 1
      );
      this.city = this.providedPin ? this.providedPin.name : "";
      this.state = this.providedPin ? this.providedPin.state : "";
      this.resiStdCode = this.providedPin
        ? this.providedPin.std
          ? this.providedPin.std[0]
          : ""
        : "";
      this.providedPin ? this.personalForm.get('fcnPincode').setErrors(null) : this.personalForm.get('fcnPincode').setErrors({ 'pinNotFound': true });
    } else {
      this.providedPin = null;
      this.city = "";
      this.state = "";
      this.resiStdCode = "";
    }
    this.sharedData.resiCity = this.city;
    this.sharedData.resiState = this.state;
    this.sharedData.resiStdCode = this.resiStdCode;
  }

  numberOnly(event) {
    if (this.f.fcnPincode.value.length < 1) {
      let regex1 = /[1-9]/;
      if (event.key.match(regex1)) {
        return true;
      } else {
        return false;
      }
    } else {
      let regex2 = /[0-9]/;
      if (event.key.match(regex2)) {
        return true;
      } else {
        return false;
      }
    }
  }

  callFormAbandon(label) {
    if (!this.sharedData.formFieldTouch) {
      this.sharedData.formFieldTouch = true;
      if(window['_satellite']){
        _satellite.track('form_start')
      }
    }
    let abandonRequest: any;
    abandonRequest = {
      section: "Persoanl Details",
      field: label
    }
    this.sharedData.setAnalyticsFormAbandon(abandonRequest);
  }
}
